import { useTranslation } from 'react-i18next';

import classes from './TableHead.module.scss';

export default function TableHead() {
  const { t } = useTranslation('panel');
  return (
    <thead>
      <tr className={classes.thead}>
        <th>{t('Raw')}</th>
        <th>{t('Username')}</th>
        <th>{t('Company')}</th>
        <th>{t('Address')}</th>
        <th>{t('Access Level')}</th>
        <th>{t('Edit')}</th>
      </tr>
    </thead>
  );
}
